import * as React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';

import {
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
  WithStyles,
  withStyles,
} from '@nelnet/unifi-components-react';

import styles from './styles';

interface IDescriptionListProps extends WithStyles<typeof styles> {
  title: RichTextBlock[];
  summary?: RichTextBlock[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list_items?: Array<any>;
  parent_slug?: string;
}

const DescriptionList: React.FunctionComponent<IDescriptionListProps> = ({
  classes,
  title,
  summary,
  list_items,
  parent_slug,
}) => {
  if (summary) {
    return (
      <>
        <Grid container className={classes.container}>
          <Grid item xs={12} padding={{ bottom: 6 }}>
            <Typography variant="h2">{RichText.asText(title)}</Typography>
            {summary ? <div className={classes.bold}>{RichText.render(summary)}</div> : null}
          </Grid>
          <Grid item xs={12} padding={{ right: 4, left: 4 }}>
            <List datalist="horizontal">
              {list_items.map((item, i) => {
                const link_uid = item.node._meta.uid;
                const item_title = item.node.title[0].text;
                const item_summary = item.node.header_content[0].text;
                const item_link = (
                  <Link underline="always" href={`/${parent_slug}/${link_uid}/`}>
                    {item_title}
                  </Link>
                );
                return (
                  <ListItem className={classes.listItem} key={i}>
                    <ListItemText primary={item_link} secondary={item_summary} />
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return (
      <>
        <Grid container className={classes.container}>
          <Grid item xs={12} padding={{ bottom: 6 }}>
            <Typography variant="h2">{RichText.asText(title)}</Typography>
          </Grid>
          <Grid item xs={12} padding={{ right: 4, left: 4 }}>
            <List datalist="horizontal">
              {list_items.map((item, i) => {
                const item_title = item.node.title[0].text;
                const page_section = item.node._meta.uid;
                const item_summary = item.node.description[0].text;
                const group = item.node._meta.tags[0]
                  ? item.node._meta.tags[0].toLowerCase()
                  : null;
                const item_link = (
                  <Link underline="always" href={`/${parent_slug}/${group}#${page_section}`}>
                    {item_title}
                  </Link>
                );
                return (
                  <ListItem className={classes.listItem} key={i}>
                    <ListItemText primary={item_link} secondary={item_summary} />
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </>
    );
  }
};

export default withStyles(styles)(DescriptionList);
